import {
	Grid2,
	IconButton,
	makeStyles,
	Paper,
	Skeleton,
	styled,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
} from '@mui/material';
import { useMainCustomStyle } from '../assets/theme/Theme';
import SideNavigationBar from '../components/SideNavigationBar';
import { useEffect, useRef, useState } from 'react';
import { ChatHistoryListResponse, ChatHistory } from '../types';
import { fetchChatHistoryList } from '../services/ApiService';
import _ from 'lodash';
import { convertTo12HourTime, dateFormatter } from '../Utils/Helpers';

function ChatHistoryList() {
	const mainDivStyle = useMainCustomStyle();
	const [chatUserList, setChatUserList] = useState<Array<ChatHistory>>([]);
	const [rowsPerPage, setRowsPerPage] = useState(8);
	const [page, setPage] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		getAllChatHistory();
	}, []);

	async function getAllChatHistory() {
		setIsLoading(true);
		const data: Array<ChatHistoryListResponse> =
			await fetchChatHistoryList();

		const orderByTime = _.orderBy(data, 'timestamp', 'desc');

		const sortedData: Array<ChatHistory> = orderByTime.map(item => {
			const convertTime = convertTo12HourTime(
				item.timestamp.split(' ')[1],
			);
			const value: ChatHistory = {
				messageDate: dateFormatter(item.timestamp.split(' ')[0]),
				messageTime: convertTime,
				phoneNumber: item.session_id.split(' ')[0],
				name:
					item.Name !== 'Unknown' && item.Name !== ''
						? item.Name
						: 'N/A',
			};

			return value;
		});

		setChatUserList(sortedData);
		setIsLoading(false);
	}

	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		newPage: number,
	) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<>
			<SideNavigationBar />
			<div style={mainDivStyle}>
				<Grid2 container paddingLeft={'20px'} paddingRight={'20px'}>
					<Grid2
						container
						sx={{ paddingLeft: '10px', width: '100%' }}>
						<TableContainer
							component={Paper}
							style={{
								boxShadow: 'none',
							}}>
							<Table
								sx={{ minWidth: 700, width: '100%' }}
								aria-label="customized table">
								<TableHead>
									<TableRow>
										<StyledTableCell align="center">
											<TableHeaderText>
												Client Number
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Client Name
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Date
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Time
											</TableHeaderText>
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{isLoading ? (
										[...Array(4)].map((_, index) => (
											<StyledTableCell
												key={index}
												align="center">
												<Skeleton
													animation="wave"
													style={{
														borderRadius: '5px',
													}}
													variant="rounded"
												/>
											</StyledTableCell>
										))
									) : chatUserList &&
									  chatUserList.length > 0 ? (
										chatUserList
											.slice(
												page * rowsPerPage,
												page * rowsPerPage +
													rowsPerPage,
											)
											.map((chat, index) => {
												return (
													<StyledTableRow key={index}>
														<StyledTableCell align="center">
															<TableRowText>
																{
																	chat.phoneNumber
																}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{chat.name}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{
																	chat.messageDate
																}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{
																	chat.messageTime
																}
															</TableRowText>
														</StyledTableCell>
													</StyledTableRow>
												);
											})
									) : (
										<StyledTableRow>
											<StyledTableCell
												colSpan={5}
												align="center">
												<TableRowText>
													No data available
												</TableRowText>
											</StyledTableCell>
										</StyledTableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[]}
							component="div"
							count={chatUserList && chatUserList.length}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</Grid2>
				</Grid2>
			</div>
		</>
	);
}

export const StyledTableCell = styled(TableCell)(() => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#FFFFFF',
		color: 'rgba(0, 0, 0, 0.5)',
		paddingTop: '20px',
		fontSize: 12,
		fontWeight: 600,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		fontWeight: 400,
		color: '#000000',
		maxWidth: 80,
	},
}));

export const StyledTableRow = styled(TableRow)(() => ({
	'&:nth-of-type(odd)': {
		background:
			'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #C2C9D1',
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

export const TableHeaderText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '600',
	color: 'rgba(0, 0, 0, 0.5)',
}));

export const TableRowText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '400',
	color: 'rgba(0, 0, 0, 1)',
}));

export default ChatHistoryList;
